import { http } from 'utils';
import { ENDPOINTS } from 'constants/routes';
import { HTTP_METHODS } from 'constants/http';

export const fetchSocialsGoogleToken = (data) => http({
  url: ENDPOINTS.socialsGoogleLogin,
  method: HTTP_METHODS.POST,
  data,
});
